import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { InsadminService } from '../../services/insadmin/insadmin.service';
import { HelperService } from 'src/app/common-service/helper.service';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-proformaview',
  templateUrl: './proformaview.component.html',
  styleUrls: ['./proformaview.component.css']
})
export class ProformaviewComponent implements OnInit {
  subscribe: Subject<any> = new Subject<any>();
proformaDetails : any = [];
proformaDetailss : any = [];

inspectionid:any;
public form: FormGroup;

  constructor(public router: Router,public route: ActivatedRoute,public insadmin: InsadminService,public helper: HelperService) { }

  ngOnInit(): void {

    this.route.params.subscribe(params => {
      if(params.id!=undefined){

        this.insadmin.getProformaDetails(params.id)
      .pipe(takeUntil(this.subscribe))
      .subscribe((data: any) => {
      this.proformaDetails = data[0];
      this.proformaDetailss= data[1];
      this.inspectionid=data[0]?.appointedInspectorId.inspectionScheduleMaster.inspectionId;

      this.proformaDetails.sectionss=this.proformaDetailss;

//ADDED BY GOKUL
 for(let i=0; i<this.proformaDetails.sections.length ; i++){
  for(let j=0; j<this.proformaDetails.sections[i].flds.length ; j++){
    this.proformaDetails.sections[i].flds[j].actualValue2=this.proformaDetailss.sections[i].flds[j].actualValue;
    this.proformaDetails.sections[i].flds[j].readOnlyValue2=this.proformaDetailss.sections[i].flds[j].readOnlyValue;

  }
 }

      }, error => {
        console.log(error);
        this.helper.errorMessage(error);
      });

        

      }
    });


    
  }
  Back() {
    this.router.navigate(['main/internal/inspection/insCell/insreport/proformagridview', this.inspectionid ]);
}

printComponent() {

  let printContents, popupWin;
    printContents = document.getElementById('proformaView').innerHTML;
     // printContents="<table><tr><td>test></td></tr><tr><td>test></td></tr><tr><td>test></td></tr></table>"
      popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
      popupWin.document.open();
      popupWin.document.write(`
        <html>
          <head>
            
            <style>
            <link rel="stylesheet" href="./assets/styles/ag-grid.css" />
            <link rel="stylesheet" href="./assets/styles/ag-theme-alpine.css" />
            </style>
          </head>
      <body onload="window.print();window.close()">${printContents}</body>
        </html>`
      );
      popupWin.document.close();

}


}
